import React from 'react';
import { Stack } from '@mui/material';

import { TrussEnvelope } from '@paragon/contract-library';

import { recalculateExistingTrussEnvelopes } from '../../../../store/actions/layout/trussEnvelopeActions';
import { useAppDispatch } from '../../../hooks';
import { RecalculateButton } from './RecalculateButton';

export function ExistingEnvelopeRecalculationControl(props: { envelopes: TrussEnvelope[]; disabled?: boolean }) {
  const dispatch = useAppDispatch();

  return (
    <Stack direction="row" sx={{ justifyContent: 'flex-end' }}>
      <RecalculateButton
        disabled={props.disabled}
        onRecalculate={async (end) => {
          await dispatch(recalculateExistingTrussEnvelopes(props.envelopes, { end }));
        }}
      />
    </Stack>
  );
}
